import { makeStyles } from '@map/theme';
import { isFirefox } from '@shared/util/userAgents';
import { ComponentProps } from 'react';
import TextFormField from './TextFormField';

const useStyles = makeStyles(() => ({
  field: {
    justifyContent: 'center',
  },
  input: {
    fontFamily: 'monospace',
    fontSize: '1.5rem',
    letterSpacing: '1ch',
    width: 'auto',
    marginRight: '-0.6em',
  },
}));

type Props = Omit<ComponentProps<typeof TextFormField>, 'type'> & {
  length?: number;
};
const OneTimeCodeField: FC<Props> = ({ length = 6, ...restProps }) => {
  const { classes, cx } = useStyles();

  return (
    <TextFormField
      {...restProps}
      type="text"
      characters="special"
      placeholder={'_'.repeat(length)}
      InputProps={{ className: classes.field }}
      inputProps={{
        minlength: length,
        maxlength: length,
        size: isFirefox ? length : length * 2,
        inputMode: 'numeric',
        autoComplete: 'one-time-code',
        ...restProps.inputProps,
        className: cx(classes.input, restProps.inputProps?.className),
      }}
    />
  );
};

export default OneTimeCodeField;
